module.exports = __webpack_public_path__ + "img/anon.dfed0933.jpg";